import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Button } from 'ui-components/components/button';
import { ButtonThemeService } from 'ui-components/services/button-theme-service';

import Global from '../../../../../store/global-selectors';
import ProcessBatchHotkey from '../../../../../components/hotkeys/advanced-hotkeys/process-batch';

import style from './style.module.less';
import { startBatchesShipmentPurchase } from '../../../../../store/batches/purchase/batches.purchase.actions';
import { EventSourceStrings } from '../../../../../tracking/tracking-constants';
import { LabelPurchaseButton } from '../../../../../components/label-purchase-button';

export const messages = defineMessages({
  processShipments: {
    description: 'processShipmentsButton.processShipments',
    defaultMessage: 'Process Shipments',
    id: 'zqRM5f',
  },
  processAndPrintShipment: {
    description: 'processShipmentsButton.processAndPrintShipment',
    defaultMessage: 'Process + Print Shipments',
    id: 'YO0DrY',
  },
});

const ProcessShipmentsButton = ({ batchId, theme = 'primary' }) => {
  const shouldBeDisabled = useSelector((state) => {
    const batchDetails = Global.selectBatchDetailsBatch(state);
    const { shipmentCount = 0 } = batchDetails;
    const userHasShippingRole = Global.selectUserhasShippingRole(state);
    return shipmentCount === 0 || !userHasShippingRole;
  });
  const fulfillmentPlanIds = useSelector(Global.selectOrdersGridOrders);

  const dispatch = useDispatch();
  const processShipments = useCallback(() => {
    dispatch(startBatchesShipmentPurchase(batchId, false));
  }, [dispatch, batchId]);
  const processAndPrintShipments = useCallback(() => {
    dispatch(startBatchesShipmentPurchase(batchId, true));
  }, [dispatch, batchId]);

  return (
    <ProcessBatchHotkey batchId={batchId} disabled={shouldBeDisabled}>
      <div className={classNames('button-group', style['button-container'], style['process-shipments-button'])}>
        <LabelPurchaseButton
          fulfillmentPlanIds={fulfillmentPlanIds}
          labelPurchaseCallback={processShipments}
          trackingId={EventSourceStrings.PROCESS_SHIPMENTS_BUTTON}
        >
          {({ onClick }) => (
            <Button className={style['button-styles']} disabled={shouldBeDisabled} onClick={onClick} theme={theme}>
              <FormattedMessage {...messages.processShipments} />
            </Button>
          )}
        </LabelPurchaseButton>
        <DropdownMenu
          closeWhenChildrenClicked={false}
          disabled={shouldBeDisabled}
          dropdownMenuClassName={style['dropdown-menu']}
          menuPosition='bottom-right'
        >
          <DropdownMenuToggler className={style['drop-down-menu-button']} theme={theme} />
          <LabelPurchaseButton
            fulfillmentPlanIds={fulfillmentPlanIds}
            labelPurchaseCallback={processAndPrintShipments}
            trackingId={EventSourceStrings.PROCESS_SHIPMENTS_BUTTON}
          >
            {({ onClick }) => (
              <DropdownMenuItem onClick={onClick}>
                <FormattedMessage {...messages.processAndPrintShipment} />
              </DropdownMenuItem>
            )}
          </LabelPurchaseButton>
        </DropdownMenu>
      </div>
    </ProcessBatchHotkey>
  );
};

ProcessShipmentsButton.propTypes = {
  batchId: PropTypes.string,
  theme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
};

export default ProcessShipmentsButton;
